import Vue from 'vue';
import detailInfo from '../../components/insurance/detail-info.vue';
export default Vue.extend({
    name: 'login',
    components: {
        detailInfo: detailInfo,
    },
    created: function () {
        // policyCode: arr,
        //       selectAmout: this.selectAmout
    },
    computed: {},
    watch: {},
    data: function () {
        return {
            inforQuery: '',
            query: {},
            info: [],
            operation: false,
            activeName: 'first',
            type: '',
            polictData: {},
            active: 1,
            radio: false,
        };
    },
    methods: {
        goBackApply: function () {
            // 提交申请逻辑
            this.$router.push({
                name: 'applyLoan',
            });
        },
        showMyApply: function () {
            this.$router.push({
                name: 'applyMine',
            });
        },
    },
});
